// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__17-yU","errorLogs":"styles_errorLogs__1RnLo"};